// Recent projects ring buffer (localStorage).
// Stores the last 5 distinct {id, name, language, language_label, openedAt}.

const RECENT_KEY = "runbox:recent-projects";
const MAX_RECENT = 5;

export function readRecent() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.slice(0, MAX_RECENT) : [];
  } catch (_) {
    return [];
  }
}

export function pushRecent(project) {
  if (!project || !project.id) return;
  const entry = {
    id: project.id,
    name: project.name || "Untitled",
    language: project.language,
    openedAt: Date.now(),
  };
  let list = readRecent().filter((p) => p.id !== entry.id);
  list.unshift(entry);
  list = list.slice(0, MAX_RECENT);
  try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (_) { /* */ }
}

export function removeRecent(id) {
  const list = readRecent().filter((p) => p.id !== id);
  try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (_) { /* */ }
}

export function clearRecent() {
  try { localStorage.removeItem(RECENT_KEY); } catch (_) { /* */ }
}
